export class RestoreAccountMetricsConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "AccountMetricsDestination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreAccountMetricsConfig.attributeTypeMap;
    }
    constructor() {
    }
}
